<mat-accordion class="expandable-panel__accordion" displayMode="flat">
  <mat-expansion-panel class="expandable-panel__panel">
    <mat-expansion-panel-header>
      <ng-content select="[expandable-panel-title]"></ng-content>
    </mat-expansion-panel-header>
    <ng-content select="[expandable-panel-content]"></ng-content>
  </mat-expansion-panel>
</mat-accordion>
